"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageElement = function ImageElement(_ref) {
  var item = _ref.item;
  console.log("ESTILOS img field: ", item);
  var defaultStyles = item.attributes.styles;
  var style = !item.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(item.customStyles);
  console.log("ESTILOS img style: ", style);
  return /*#__PURE__*/React.createElement("img", {
    src: item.attributes.src,
    width: item.attributes.width,
    height: item.attributes.height,
    alt: item.attributes.alt,
    srcset: item.attributes.srcset,
    sizes: item.attributes.sizes,
    style: style
  });
};

var _default = ImageElement;
exports.default = _default;